import { COLLECTION_VIEW_ROUTE } from '@config/routeNames.js'
import { Settings } from '@config/game.js'

export const schema = {
  config: [
    {
      type: 'group',
      to: _goToCollection,
      key: 'name',
      cellClass: 'tw-text-left',
      sortable: false,
      group: [
        {
          label: 'Preview',
          key: 'logo.thumb_320x180',
          size: {
            w: '24',
            h: '12',
          },
          type: 'image',
        },
        {
          label: 'name',
          key: 'name',
          type: 'string',
        },
      ],
    },
  ],
  noHeader: true,
}

if (Settings.value.allowSubscribing) {
  schema.config.push({
    actionCell: true,
    type: 'group',
    cellClass: 'tw-text-right',
    sortable: false,
    group: [
      (item) => ({
        type: 'action',
        attrs: {
          danger: !item.unfollowed,
          primary: item.unfollowed,
          icon: item.unfollowed ? 'plus' : 'times',
        },
        text: item.unfollowed ? 'Follow' : 'Unfollow',
        onClick: 'toggleFollow',
      }),
    ],
  })
}

function _goToCollection(collection) {
  return {
    name: COLLECTION_VIEW_ROUTE,
    params: { collection: collection.name_id },
  }
}
